module.exports = __webpack_public_path__ + "static/media/success.6d2472e6.svg";